import { FiSettings, FiSliders, FiPlus, FiUser, FiTool, FiCreditCard, FiDatabase } from 'react-icons/fi';
import { Link } from 'react-router-dom';

export default function Settings() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center mb-2">
          <FiSettings className="w-6 h-6 text-gray-600 mr-3" />
          <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        </div>
        <p className="text-gray-600">
          Configure system settings and manage application features.
        </p>
      </div>

      {/* Settings Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        
        {/* Manage Attributes Card */}
        <Link
          to="/settings/attributes"
          className="bg-white rounded-lg border border-gray-200 p-6 hover:border-blue-300 hover:shadow-md transition-all duration-200 group"
        >
          <div className="flex items-center mb-4">
            <div className="bg-blue-100 p-3 rounded-lg group-hover:bg-blue-200 transition-colors duration-200">
              <FiSliders className="w-6 h-6 text-blue-600" />
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Manage Attributes
          </h3>
          <p className="text-gray-600 text-sm mb-4">
            Create and manage custom attributes for agents such as certifications, skills, and experience levels.
          </p>
          <div className="text-blue-600 text-sm font-medium flex items-center">
            Configure attributes
            <FiPlus className="w-4 h-4 ml-1" />
          </div>
        </Link>

        {/* Caps Card */}
        <Link
          to="/settings/caps"
          className="bg-white rounded-lg border border-gray-200 p-6 hover:border-blue-300 hover:shadow-md transition-all duration-200 group"
        >
          <div className="flex items-center mb-4">
            <div className="bg-blue-100 p-3 rounded-lg group-hover:bg-blue-200 transition-colors duration-200">
              <FiUser className="w-6 h-6 text-blue-600" />
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Caps
          </h3>
          <p className="text-gray-600 text-sm mb-4">
            Limit member workload using Distributely assignments, HubSpot workload, or both.
          </p>
          <div className="text-blue-600 text-sm font-medium flex items-center">
            Manage caps
            <FiPlus className="w-4 h-4 ml-1" />
          </div>
        </Link>

        {/* Portal Defaults Card */}
        <Link
          to="/settings/portal"
          className="bg-white rounded-lg border border-gray-200 p-6 hover:border-blue-300 hover:shadow-md transition-all duration-200 group"
        >
          <div className="flex items-center mb-4">
            <div className="bg-blue-100 p-3 rounded-lg group-hover:bg-blue-200 transition-colors duration-200">
              <FiSettings className="w-6 h-6 text-blue-600" />
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Portal Defaults
          </h3>
          <p className="text-gray-600 text-sm mb-4">
            Set the fallback owner and default timezone for cap boundaries.
          </p>
          <div className="text-blue-600 text-sm font-medium flex items-center">
            Configure defaults
            <FiPlus className="w-4 h-4 ml-1" />
          </div>
        </Link>

        {/* Manage Custom Objects Card */}
        <Link
          to="/settings/custom-objects"
          className="bg-white rounded-lg border border-gray-200 p-6 hover:border-blue-300 hover:shadow-md transition-all duration-200 group"
        >
          <div className="flex items-center mb-4">
            <div className="bg-blue-100 p-3 rounded-lg group-hover:bg-blue-200 transition-colors duration-200">
              <FiTool className="w-6 h-6 text-blue-600" />
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Manage Custom Objects
          </h3>
          <p className="text-gray-600 text-sm mb-4">
            Configure custom HubSpot object types per portal for routing.
          </p>
          <div className="text-blue-600 text-sm font-medium flex items-center">
            Manage objects
            <FiPlus className="w-4 h-4 ml-1" />
          </div>
        </Link>

        <Link
            // to="/settings/billing"
          className="bg-gray-50 rounded-lg border border-gray-200 p-6 opacity-60 group"
        >
          <div className="flex items-center mb-4">
            <div className="bg-gray-200 p-3 rounded-lg">
              <FiCreditCard className="w-6 h-6 text-gray-400" />
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-500 mb-2">
            Billing
          </h3>
          <p className="text-gray-400 text-sm mb-4">
            View account trial status, payment method readiness, and billing state.
          </p>
          <div className="text-gray-400 text-sm font-medium">
            Coming soon
          </div>
        </Link>

        {/* Member Caching Card */}
        <Link
          to="/settings/member-caching"
          className="bg-white rounded-lg border border-gray-200 p-6 hover:border-blue-300 hover:shadow-md transition-all duration-200 group"
        >
          <div className="flex items-center mb-4">
            <div className="bg-blue-100 p-3 rounded-lg group-hover:bg-blue-200 transition-colors duration-200">
              <FiDatabase className="w-6 h-6 text-blue-600" />
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Member Caching
          </h3>
          <p className="text-gray-600 text-sm mb-4">
            Control whether HubSpot owner data is served live or from a local cache to improve routing performance.
          </p>
          <div className="text-blue-600 text-sm font-medium flex items-center">
            Configure caching
            <FiPlus className="w-4 h-4 ml-1" />
          </div>
        </Link>

        {/* Another placeholder */}
        <div className="bg-gray-50 rounded-lg border border-gray-200 p-6 opacity-60">
          <div className="flex items-center mb-4">
            <div className="bg-gray-200 p-3 rounded-lg">
              <FiSettings className="w-6 h-6 text-gray-400" />
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-500 mb-2">
            System Configuration
          </h3>
          <p className="text-gray-400 text-sm mb-4">
            System-wide configuration options will be available here.
          </p>
          <div className="text-gray-400 text-sm font-medium">
            Coming soon
          </div>
        </div>

        <Link
            to="/settings/external-systems"
            className="bg-white rounded-lg border border-gray-200 p-6 hover:border-blue-300 hover:shadow-md transition-all duration-200 group"
        >
          <div className="flex items-center mb-4">
            <div className="bg-blue-100 p-3 rounded-lg group-hover:bg-blue-200 transition-colors duration-200">
              <FiTool className="w-6 h-6 text-blue-600" />
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Connect External Systems
          </h3>
          <p className="text-gray-600 text-sm mb-4">
            Connect external systems to Distributely.
          </p>
          <div className="text-blue-600 text-sm font-medium flex items-center">
            Manage Connections
            <FiPlus className="w-4 h-4 ml-1" />
          </div>
        </Link>

      </div>

      {/* Info Section */}
      {/*<div className="mt-12 bg-blue-50 border border-blue-200 rounded-lg p-6">*/}
      {/*  <div className="flex items-start">*/}
      {/*    <FiSettings className="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />*/}
      {/*    <div>*/}
      {/*      <h3 className="text-sm font-semibold text-blue-900 mb-1">*/}
      {/*        Settings Overview*/}
      {/*      </h3>*/}
      {/*      <p className="text-sm text-blue-700">*/}
      {/*        This settings panel provides access to configuration options for the Distributely system. */}
      {/*        Start with managing attributes to customize how agent information is tracked and organized. */}
      {/*        Additional configuration options will be added in future updates.*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
}
